document.querySelectorAll('.collection-carousel').forEach(carousel => {
    const viewport = carousel.querySelector('.carousel-viewport');
    const slides = [...carousel.querySelectorAll('.carousel-slide')];
    const dotsContainer = carousel.querySelector('.carousel-dots');
    const prevBtn = carousel.querySelector('.carousel-prev');
    const nextBtn = carousel.querySelector('.carousel-next');

    const visibleSlides = 3;
    const slidesCount = slides.length;
    const dotsCount = slidesCount - visibleSlides + 1;

    if (dotsCount <= 1) {
        dotsContainer.style.display = 'none';
        return;
    }

    let activeIndex = 0;

    function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = activeIndex === 0;
        nextBtn.disabled = activeIndex === dotsCount - 1;
    }

    function scrollToIndex(index) {
        activeIndex = Math.max(0, Math.min(index, dotsCount - 1));

        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            viewport.scrollTo({
                top: slides[activeIndex].offsetTop,
                behavior: 'smooth'
            });
        } else {
            const slideWidth = slides[0].offsetWidth;
            viewport.scrollTo({
                left: slideWidth * activeIndex,
                behavior: 'smooth'
            });
        }
        updateDots();
        updateArrows();
    }

    function updateDots() {
        dotsContainer.querySelectorAll('button').forEach((dot, i) => {
            dot.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
        });
    }

    for (let i = 0; i < dotsCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Go to slide group ${i + 1}`);
        dot.addEventListener('click', () => scrollToIndex(i));
        dotsContainer.appendChild(dot);
    }

    if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', () => scrollToIndex(activeIndex - 1));
        nextBtn.addEventListener('click', () => scrollToIndex(activeIndex + 1));
        updateArrows();
    }

    updateDots();

    let ticking = false;
    viewport.addEventListener('scroll', () => {
        const isMobile = window.innerWidth <= 768;
        if (!isMobile || ticking) return;

        ticking = true;
        requestAnimationFrame(() => {
            const slideSize = slides[0].offsetHeight;
            const index = Math.round(viewport.scrollTop / slideSize);
            activeIndex = Math.min(index, dotsCount - 1);
            updateDots();
            updateArrows();
            ticking = false;
        });
    });
});